import MaterialPriceListScaleAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list-scales/material-price-list-scales.entity';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IAPIListResult } from 'app/common/interfaces';
import { MaterialPriceListScaleService } from './table-price-list.service';

@Component({
  selector: 'app-table-price-list',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule,
    MatDatepickerModule
  ],
  templateUrl: './table-price-list.component.html',
  styleUrl: './table-price-list.component.scss'
})
export class TablePriceListComponent {
  private data!: MaterialPriceListAttributes;

  @Input('data') 
  set _data(value: MaterialPriceListAttributes) {
    this.data = value;
    if (this.data) {
      this.getList()
    }
  }
  @Output() materialPriceChange: EventEmitter<any> = new EventEmitter();

  openFormAdd = false
  listScalesAdd: MaterialPriceListScaleAttributes[] = []

  currentCreateScale: MaterialPriceListScaleAttributes = this.initializeCreateScales();

  constructor(
    private materialPriceScaleService: MaterialPriceListScaleService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngAfterViewInit(): void {
  }

  getList(){
    this.materialPriceScaleService.getAllMaterialScale(String(this.data._id)).subscribe({
      next: (res: IAPIListResult<MaterialPriceListScaleAttributes>) => {
        this.listScalesAdd = res?.data.map((account) => {
          return {
            ...account,
            isEditMode: false,
          };
        });
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener el registro","Cerrar",{ duration: 5000});
      },
    });
  }

  private initializeCreateScales(): MaterialPriceListScaleAttributes {
    return { quantityFrom: null, quantityTo: null, price: null, minimumPrice: 0, maximumPrice: 0};
  }

  onAddToListScale(){
    if(this.currentCreateScale.quantityFrom == null || this.currentCreateScale.quantityTo == null){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    if(this.currentCreateScale.price == null){
      this.snackBar.open("Ingrese una precio", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    if(false){  //v1
      let auxData = this.listScalesAdd.slice()
      auxData.push(this.currentCreateScale)
  
      this.listScalesAdd = auxData
      this.resetFormAddListScale()
      this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
      this.openFormAdd = false
      this.saveGlobal()
      this.cdr.detectChanges()
  
    }else{ //v2
      this.materialPriceScaleService.createEmbedded(String(this.data._id), this.currentCreateScale).subscribe({
        next: () => {
          this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
          this.openFormAdd = false
          this.resetFormAddListScale()
          this.saveGlobal()
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  resetFormAddListScale() {
    this.currentCreateScale = {
      quantityFrom: null,
      quantityTo: null,
      minimumPrice: 0,
      maximumPrice: 0,
      price: null
    }
  }

  onUpdateScale(element, i){
    element.isEditMode = true;
  }

  onSaveScale(element, i){
    if(element.quantityFrom == null || element.quantityTo == null){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    if(element.price == null){
      this.snackBar.open("Ingrese una precio", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    element.isEditMode = false;

    if(false){
      let auxData = this.listScalesAdd.slice()
      auxData.splice(i, 1, element)
      this.listScalesAdd = auxData
      this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
      this.saveGlobal()
      this.cdr.detectChanges()
    }else{
      this.materialPriceScaleService.updateEmbedded(String(this.data._id), String(element._id), element).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.saveGlobal()
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onDeleteScale(element, i) {
    if(false){
      let auxData = this.listScalesAdd.slice()
      auxData.splice(i, 1)
      this.listScalesAdd = auxData
      this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
      this.cdr.detectChanges()
    }else{
      this.materialPriceScaleService.deleteEmbedded1d(String(this.data._id), element._id).subscribe({
        next: () => {
          this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al eliminar el horario","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      })
    }
  }

  saveGlobal(){
    this.materialPriceChange.emit(this.listScalesAdd)
  }
}
